// set defaults on the HTML element specifically, but not lightBase
// because that would wreck the point of the "base" themes, which is
// to have the theme minus the background
html[data-design-version="v2026"] {
    background: var(--color-primary);
    color: var(--color-contrast);
}

html[data-design-version="v2026"],
.lightBase {
    --color-primary: var(--white);
    --color-contrast: var(--black);
    --color-contrast-muted: var(--gray-900);
    --color-contrast-subtle: var(--gray-700);
    --form-label-color: var(--color-contrast);
    --field-border-color: var(--gray-300);
    --field-border-color-focus: var(--gray-700);
    --primary-button-background: var(--overlay-off-white-20);
    --primary-button-text: var(--black);
    --primary-button-disabled-background: var(--gray-100);
    --primary-button-disabled-text: var(--gray-700);
    --secondary-button-background: var(--black);
    --secondary-button-border: var(--gray-700);
    --secondary-button-text: var(--off-white);
    --secondary-button-hover-background: var(--secondary-button-background);
    --secondary-button-hover-border: var(--secondary-button-border);
    --secondary-button-hover-text: var(--white);
    --secondary-button-disabled-background: var(--secondary-button-background);
    --secondary-button-disabled-text: var(--gray-300);
    --overlay-20: var(--overlay-off-white-20);
    --overlay-56: var(--overlay-off-white-56);
    --overlay-gradient: var(--overlay-white-gradient);
    --accent: var(--red);
    --progress-track: var(--gray-300);
    --dot-color: var(--gray-700);
    --dot-active-color: var(--black);
    --dot-overlay: var(--overlay-off-white-20);
    --dot-stroke: var(--overlay-off-white-20);
}

.darkBase {
    --color-primary: var(--black);
    --color-contrast: var(--off-white);
    --color-contrast-muted: var(--gray-100);
    --color-contrast-subtle: var(--gray-300);
    --form-label-color: var(--beige);
    --field-border-color: var(--off-white);
    --field-border-color-focus: var(--gray-500);
    --primary-button-background: var(--overlay-black-20);
    --primary-button-text: var(--off-white);
    --primary-button-disabled-background: var(--overlay-black-20);
    --primary-button-disabled-text: var(--gray-300);
    --secondary-button-background: var(--off-white);
    --secondary-button-border: var(--gray-300);
    --secondary-button-text: var(--black);
    --secondary-button-hover-background: var(--white);
    --secondary-button-hover-border: var(--gray-100);
    --secondary-button-hover-text: var(--secondary-button-text);
    --secondary-button-disabled-background: var(--gray-100);
    --secondary-button-disabled-text: var(--gray-700);
    --overlay-20: var(--overlay-black-20);
    --overlay-56: var(--overlay-black-56);
    --overlay-gradient: var(--overlay-black-gradient);
    --accent: var(--pecan);
    --progress-track: var(--gray-500);
    --dot-color: var(--gray-300);
    --dot-active-color: var(--off-white);
    --dot-overlay: var(--overlay-off-white-20);
    --dot-stroke: var(--overlay-black-20);
}

// Not sure if necessary, just a helper class that makes it clear that we're
// activating certain CSS properties for the theme
.themed {
    background: var(--color-primary);
    color: var(--color-contrast);
}

// lightBase + activated text color and an explicitly transparent background
.lightThemeText {
    composes: lightBase;
    background: transparent;
    color: var(--color-contrast);
}

// darkBase + activated text color and an explicitly transparent background
.darkThemeText {
    composes: darkBase;
    background: transparent;
    color: var(--color-contrast);
}

.white {
    composes: lightBase;
    composes: themed;
}

.offWhite {
    composes: lightBase;
    composes: themed;

    --color-primary: var(--off-white);
}

.beige {
    composes: lightBase;
    composes: themed;

    --color-primary: var(--beige);
    --field-border-color: var(--gray-500);
    --field-border-color-focus: var(--black);
}

.beigePecan {
    composes: beige;
    background: var(--gradient-light-2);
}

.lightMaroon {
    composes: lightBase;
    composes: themed;
    background: var(--gradient-light-3);
}

.black {
    composes: darkBase;
    composes: themed;
}

.eggplantGradient {
    composes: darkBase;
    composes: themed;
    background: var(--gradient-dark-2);
}

.maroon {
    composes: darkBase;
    composes: themed;

    --color-primary: var(--maroon);
}

.maroonGradient {
    composes: maroon;
    background: var(--gradient-dark-3);
}
